module.exports = __webpack_public_path__ + "img/3541619596313_.pic_hd.112d3d48.jpg";